import React from 'react';
import PageMeta from '../../components/PageMeta';

export default function InfoPageLayout({ title, description, heading, body }) {
  const canonicalUrl =
    typeof window !== 'undefined'
      ? window.location.href
      : `https://lilycove.io/${heading.toLowerCase()}`;

  return (
    <section className="py-16">
      <PageMeta title={title} description={description} url={canonicalUrl} />
      <div className="mx-auto max-w-3xl rounded-2xl border border-purple/30 bg-dark/60 p-8 md:p-10">
        <h1 className="mb-4 text-3xl font-medium text-purple">{heading}</h1>
        <p className="leading-relaxed text-cream/85">{body}</p>
      </div>
    </section>
  );
}
